import io from 'socket.io-client';
import config from 'config/config';
import actionTypes from './actionTypes';

let socket = null;
const messageTypes = [
  {
    message: 'messages.unread-count',
    type: actionTypes.UPDATE_MESSAGES_COUNT,
  },
  {
    message: 'notifications.unread-count',
    type: actionTypes.UPDATE_NOTIFICATIONS_COUNT,
  },
];

export const init = (dispatch) => {
  if (socket) {
    socket.close();
  }
  socket = io(config.WS_URL, { path: '/ws' });
  messageTypes
    .forEach(messageType => socket.on(messageType.message, (data) => {
      dispatch({
        type: messageType.type,
        data,
      });
    }));
};

export const close = () => {
  if (socket) {
    socket.close();
    socket = null;
  }
};

